import { AppState } from '@open-tender/cloud'

// A restored working modal or alert has no running thunk left to close it.
const withoutAlert = (state: any) =>
  state?.order ? { ...state, order: { ...state.order, alert: null } } : state

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    const parsed = JSON.parse(serializedState)
    if (!parsed || typeof parsed !== 'object') {
      return undefined
    }
    const { modal, ...rest } = parsed
    return withoutAlert(rest)
  } catch (err) {
    return undefined
  }
}

export const saveState = (state: AppState) => {
  try {
    const { config, menu, modal, ...rest } = state
    const serializedState = JSON.stringify(withoutAlert(rest))
    localStorage.setItem('state', serializedState)
  } catch (err) {
    // Ignore write errors.
  }
}
